import moment from 'moment';
import BaseModel from '../Base';

export default class Invite extends BaseModel {
  static entity = 'invites';

  static fields() {
    return {
      ...super.fields(),
      email: this.string(''),
      token: this.string(''),
      state: this.string(''),
      firstName: this.string(''),
      lastName: this.string(''),
      role: this.string(''),
      message: this.string(''),
      sentAt: this.attr('date'),
      resendUrl: this.string(''),
      groups_collection: this.attr([])
    };
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`;
  }

  get sentAtString() {
    return this.sentAt ? moment(this.sentAt).format('DD-MM-YYYY H:mm') : null;
  }

  get sentAtSorter() {
    return this.sentAt ? moment(this.sentAt).format('x') : 0;
  }
}
